import { Component, HostListener, OnInit } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { DatePipe } from '@angular/common'
import { MessageService } from 'primeng/api'
import {
    GlobalSettingsService,
  PatientService,
  RecentlyVisitedService,
} from '../../../../api/services'
import { environment } from '../../../../../environments/environment'
import { SelectedPatientService } from '../patient-list/patient-service'
import { UiPreferences } from '../../../../api/models/ui-preferences'
import { CareFinitySession } from '../../../services/CareFinitySession'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {


  Item = 'Dashboard'
  problem: any[]
  allergy: any[]
  medication: any[]
  visits: any[]
  labs: any[]
  orders: any[]
  private problemcols: any[]
  private allergycols: any[]
  private medcols: any[]
  private visitcols: any[]
  private labcols: any[]
  private ordercols: any[]
  patientId: string = ''
    patientName: string = ''

    preferences: UiPreferences = {};
    CareFinitySession: any;
    isAllergy: boolean = false;
    isMedication: boolean = false;
    isProblem: boolean = false;
    isVisits: boolean = false;   
    isLabs: boolean = false;
    isOrders: boolean = false;


    showDescription: boolean = false;
    modalContent = '';
    headerTitle: string = '';
    iconpath: string = '';
    dialogLeft = 0;
    dialogTop = 0;

    @HostListener('window:resize', ['$event'])
    onResize(event: UIEvent)
    {
        this.adjustDialogPosition();
    }

  constructor(
    private fb: UntypedFormBuilder,    private router: Router,    private messageService: MessageService,    private ptservice: PatientService,    private datePipe: DatePipe,    private recentVispt: RecentlyVisitedService,    private activatedRoute: ActivatedRoute,    private selectedPatientService: SelectedPatientService,
    private globalsettingService: GlobalSettingsService,    private sanitizer: DomSanitizer  ) {   debugger; }

  ngOnInit() {
    debugger
      this.getPreferences();

    this.problemcols = [
      { field: 'shortVisitDate', header: 'Date' },
      { field: 'problemDescription', header: 'Description' },
    ]
    this.allergycols = [
      { field: 'shortVisitDate', header: 'Date' },
      { field: 'allergyReaction', header: 'Allergen/Reaction' },
    ]
    this.medcols = [
      { field: 'shortStartDate', header: 'Start Date' },
      { field: 'brandDoseForm', header: 'Name/Dose' },
    ]
    this.visitcols = [
      { field: 'shortVisitDate', header: 'Visit Date' },
        { field: 'visitType', header: 'Visit Type' },
    ]
    this.labcols = [
      { field: 'orderDate', header: 'Order Date' },
      { field: 'testDescription', header: 'Test Name' },
    ]
    this.ordercols = [
      { field: 'orderedDate', header: 'Order Date' },
      { field: 'description', header: 'Description' },
      ]
      this.CareFinitySession = CareFinitySession?.user?.roles;

     
    this.loadDashBoardList()
  }
  getPreferences() {
        this.globalsettingService
            .globalSettingsGetGlobalSettings({})
            .subscribe((result) => {
                this.preferences = result
                localStorage.setItem('uiPreferences', JSON.stringify(this.preferences));

            })
    }
  loadDashBoardList() {
        debugger;
    this.ptservice
      .patientGetDashboardList({
        PatientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
      })
      .subscribe((result) => {
        debugger
          if (result.problems != null)
          {
              if (CareFinitySession?.user?.roles?.problems)
              {
                
                  this.problem =  result.problems
              }
              else
              {                
                  this.isProblem = true;
                  this.problem = null;
              }
        
           }
          if (result.allergies != null)
          {

              if (CareFinitySession?.user?.roles?.allergies) {
                
                  this.allergy = result.allergies
              }
              else {
               
                  this.isAllergy = true;
                  this.allergy = null;
              }
              
            }
          if (result.medications != null)
          {

              if (CareFinitySession?.user?.roles?.medication)
              {
                  this.medication = result.medications
              }
              else {

               
                  this.isMedication = true;

                  this.medication = null;
              }
         
          }

          if (result.visits != null)

          {

              if (CareFinitySession?.user?.roles?.visits)
              {
                
                  this.visits = result.visits
                
              }
              else {
              
                  this.isVisits = true;
                  this.visits = null;
              }
            
        }
          if (result.order != null)
          {

              if (CareFinitySession?.user?.roles?.orders) {
                  this.orders = result.order
              }
              else {
                  this.isOrders = true;

                  this.orders = null;
              }
             
        }
          if (result.labs != null)
          {
              if (CareFinitySession?.user?.roles?.labs) {
                  this.labs = result.labs
              }
              else {
                  this.isLabs = true;
                  this.labs = null;
              }

          
        }

        this.SavePatientInfoDetails()
      })
  }
  SavePatientInfoDetails() {
    this.recentVispt
      .recentlyVisitedPost({
        PatientId: sessionStorage.getItem('ptId'),
        PatientName: sessionStorage.getItem('ptName'),
        PracticeId: localStorage.getItem('PracticeId'),
      }).subscribe(
        (val) => {
            this.selectedPatientService.changePatient(this.selectedPatientService.getPatientValue())
        },
        (err) => {
            console.log(err.error);
        },
      )
  }
  formatdatetime(item, type) {
    //debugger
      if (item != null && type.indexOf('Date') > -1) {
          return this.datePipe.transform(item, environment.dateformat)
      }
      else {
          // item ="A condition where your immune system reacts to a substance (like food, dust, medicine, or pollen) as if it were harmful — even though it's usually harmless";
           return this.getSafeHtml(item);
      }

    return item
    }

    adjustDialogPosition() {
        const buffer = 10;
        const dialogWidth = 720;
        const dialogHeight = 300;
       if (window.innerWidth < 768) {

           
            // Small screen — center dialog
            this.dialogLeft = ((window.innerWidth - dialogWidth) / 2) + 90;
            this.dialogTop = 100;
        } else {
            // Large screen — keep near mouse or limit overflow
            this.dialogLeft = Math.min(this.dialogLeft, window.innerWidth - dialogWidth - buffer);
            this.dialogTop = Math.min(this.dialogTop, window.innerHeight - dialogHeight - buffer);
        }
    }

    readMoreContentWithLink(content: string): string {
        const maxLength = 110; //environment.readMoreDescriptionLength;
        if (!content) return '';
        if (content.length <= maxLength) return content;
        const truncated = content.substring(0, maxLength).trim();
        return `${truncated}<a href="#" class="read-more-link" data-full="${content}"><b style="color:#131f58">...<i class="fa fa-eye"></i></b></a>`;
    }


    handleMouseOver(event: MouseEvent, type: string, header: string): void {

        const target = (event.target as HTMLElement).closest('.read-more-link');

        if (target) {
            event.preventDefault();
            const fullText = target.getAttribute('data-full') || '';

            switch (type.toLowerCase()) {

                case "problems":
                    {
                        this.dialogLeft = event.clientX + 10; // Offset slightly so it doesn't block the mouse
                        this.dialogTop = event.clientY + 10;
                        this.headerTitle = header;
                        this.modalContent = fullText;
                        this.adjustDialogPosition();
                        this.showDescription = true;
                        this.iconpath = "../../../../assets/imagesNew/d_Problems.png";
                        break;
                    }
                case "allergy":
                    {
                        this.dialogLeft = event.clientX + 10; // Offset slightly so it doesn't block the mouse
                        this.dialogTop = event.clientY + 10;
                        this.headerTitle = header;
                        this.modalContent = fullText;
                        this.adjustDialogPosition();
                        this.showDescription = true;
                        this.iconpath = "../../../../assets/imagesNew/d_allergeis.png";
                        break;
                    }
                case "medication":
                    {
                        this.dialogLeft = event.clientX + 10; // Offset slightly so it doesn't block the mouse
                        this.dialogTop = event.clientY + 10;
                        this.headerTitle = header;
                        this.modalContent = fullText;
                        this.adjustDialogPosition();
                        this.showDescription = true;
                        this.iconpath = "../../../../assets/imagesNew/d_medication.png";
                        break;
                    }
                case "visits":
                    {
                        this.dialogLeft = event.clientX + 10; // Offset slightly so it doesn't block the mouse
                        this.dialogTop = event.clientY + 10;
                        this.headerTitle = header;
                        this.modalContent = fullText;
                        this.adjustDialogPosition();
                        this.showDescription = true;
                        this.iconpath = "../../../../assets/imagesNew/d_visits.png";
                        break;
                    }

                case "labs":
                    {
                        this.dialogLeft = event.clientX + 10; // Offset slightly so it doesn't block the mouse
                        this.dialogTop = event.clientY + 10;
                        this.headerTitle = header;
                        this.modalContent = fullText;
                        this.adjustDialogPosition();
                        this.showDescription = true;
                        this.iconpath = "../../../../assets/imagesNew/d_labs.png";
                        break;
                    }

                case "orders":
                    {
                        this.dialogLeft = event.clientX + 10; // Offset slightly so it doesn't block the mouse
                        this.dialogTop = event.clientY + 10;
                        this.headerTitle = header;
                        this.modalContent = fullText;
                        this.adjustDialogPosition();
                        this.showDescription = true;
                        this.iconpath = "../../../../assets/imagesNew/d_orders.png";
                        break;
                    }

            }
           
        }
    }


    getSafeHtml(content: string): SafeHtml
    {
        return this.sanitizer.bypassSecurityTrustHtml(this.readMoreContentWithLink(content));
    }

    viewAll(item : any) {

        alert(item);
    }
    redirectUrlLinks(itemName: string) {
        switch (itemName.toLocaleLowerCase()) {
            case "problems":
                this.router.navigate(["/Patient/problems/list"]);
                break;
            case "medication":
                this.router.navigate(["/Patient/medication/list"]);
                break;
            case "allergy":
                this.router.navigate(["/Patient/allergy/list"]);
                break;
            case "visits":
                this.router.navigate(["/Patient/visits/list"]);
                break;
            case "labs":
                this.router.navigate(["/Patient/labs/list"]);
                break;
            case "orders":
                this.router.navigate(["/Patient/orders/list"]);
                break;
            default:
                console.warn("Unknown item:", itemName);
                break;
        }
    }
}
